import AgenliteAPIClient from '~/api';
import PaymentDomainAPIClient from '~/api/payment-domain';

const WALLET_VJI_CONFIG_KEY = 'mitra-wallet-vji-config';

const initialState = {
  isWalletVjiWhitelisted: false,
  walletVjiFullyRolledOut: false,
  b2b2cAccessToken: '',
};

const getters = {
  isWalletVjiWhitelisted(state) {
    return state.isWalletVjiWhitelisted;
  },
  getWalletVjiTypeText(state) {
    return state.isWalletVjiWhitelisted ? 'BukaPay' : 'Saldo';
  },
  walletVjiFullyRolledOut(state) {
    return state.walletVjiFullyRolledOut;
  },
  isWalletVjiEnabled(state, _getters, _rootState, rootGetters) {
    if (!rootGetters?.toggleConfig?.walletVji) return false;
    return state.walletVjiFullyRolledOut || state.isWalletVjiWhitelisted;
  },
  isWalletVjiEnabledAndUnbound(_state, _getters, _rootState, rootGetters) {
    return rootGetters.isWalletVjiEnabled && !rootGetters.isWalletVjiBound;
  },
  b2b2cAccessToken(state) {
    return state.b2b2cAccessToken;
  },
};

const actions = {
  async initWalletVji({ dispatch, rootGetters }) {
    if (!rootGetters?.toggleConfig?.walletVji) return;
    await Promise.allSettled([
      dispatch('fetchWalletVjiWhitelistStatus'),
      dispatch('fetchWalletVjiConfig'),
      dispatch('generateWalletVjiB2b2cToken'),
    ]);
  },
  async fetchWalletVjiWhitelistStatus({ commit }) {
    try {
      const response = await AgenliteAPIClient.getWallet20WhitelistStatus('wallet-vji');
      commit('setWalletVjiWhitelisted', response.data.whitelisted);
    } catch (e) {
      // ignore for now
    }
  },
  async fetchWalletVjiConfig({ dispatch, commit }) {
    try {
      const config = await dispatch('fetchNeoConfigs', [WALLET_VJI_CONFIG_KEY]);
      commit('setWalletVjiFullyRolledOut', config[0]?.data['wallet-vji-fully-rolled-out'] || false);
    } catch (e) {
      // ignore for now
    }
  },
  // TODO create logic to cache the token so that it doesn't need to be called on every page load
  async generateWalletVjiB2b2cToken({ commit }) {
    try {
      const response = await PaymentDomainAPIClient.generateWalletVjiB2b2cToken();
      commit('setWalletVjiB2b2cAccessToken', response?.access_token || '');
    } catch (e) {
      // ignore for now
    }
  },
};

const mutations = {
  setWalletVjiWhitelisted(state, isWhitelisted) {
    state.isWalletVjiWhitelisted = isWhitelisted;
  },
  setWalletVjiFullyRolledOut(state, isFullyRolledOut) {
    state.walletVjiFullyRolledOut = isFullyRolledOut;
  },
  resetState(state) {
    state.isWalletVjiWhitelisted = JSON.parse(JSON.stringify(initialState.isWalletVjiWhitelisted));
    state.walletVjiFullyRolledOut = JSON.parse(JSON.stringify(initialState.walletVjiFullyRolledOut));
  },
  setWalletVjiB2b2cAccessToken(state, b2b2cAccessToken) {
    state.b2b2cAccessToken = b2b2cAccessToken;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
